import { Box, HTMLChakraProps } from '@chakra-ui/react'
import { ReactNode } from 'react'
import { isTouchDevice } from 'utils'
import { HeroIconProps, InformationCircleIcon, Popover, Text, Tooltip, TooltipProps } from '.'

export interface Props extends Omit<HTMLChakraProps<'div'>, 'children'> {
  iconProps?: HeroIconProps
  /** Allow tooltip to stay open */
  interactive?: boolean
  positioning?: TooltipProps['positioning']
  text: ReactNode
}

export default function HelpHover({ iconProps, interactive, positioning, text, ...rest }: Props) {
  const _positioning = { ...positioning, placement: positioning?.placement || 'bottom' }

  if (isTouchDevice() || interactive) {
    return (
      <Popover
        positioning={_positioning}
        autoFocus
        hideClose
        showArrow
        lazyMount
        trigger={<InformationCircleIcon cursor="pointer" type="outline" {...iconProps} />}
        {...rest}
      >
        <Box p={2} maxWidth="250px">
          {typeof text === 'string' ? (
            <Text fontSize="small" color="white">
              {text}
            </Text>
          ) : (
            text
          )}
        </Box>
      </Popover>
    )
  }

  return (
    <Tooltip
      content={text}
      openDelay={0}
      positioning={_positioning}
      width="250px"
      mt={2}
      {...(rest as any)}
    >
      <InformationCircleIcon size="md" type="outline" cursor="help" {...iconProps} />
    </Tooltip>
  )
}
